import { MinusCircleOutlineIcon } from './MinusCircleOutlineIcon';

/**
 * author: Google
 * id E1568BA6-EA0E-478F-933F-102F76996D6C
 * name minus-circle-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/minus-circle-outline.svg
 * tags
 * - Transportation + Road 
 * - Medical / Hospital 
 * - Form 
 */
export const MedicineOutlineIcon = MinusCircleOutlineIcon;
export default MedicineOutlineIcon